import axios from "axios";

const show = id => axios.get(`/api/v1/layouts/${id}`);

const update = (id, payload) =>
  axios.put(`/api/v1/layouts/${id}`, { stringified_layout: payload });

const layoutsApi = {
  show,
  update,
};

export default layoutsApi;
